import { useState } from 'react';
import { useBookingAssigneesQuery } from '../../queries/scheduling';
import NewBookingModal from '../Scheduling/NewBookingModal';
import TicketFormModal from '../Maintenance/TicketFormModal';

export function useSchedule() {
  const [open, setOpen] = useState(null);
  const { data: team = [] } = useBookingAssigneesQuery();
  const close = () => setOpen(null);
  const node =
    open?.kind === 'tour' ? (
      <NewBookingModal type="tour" assignees={team} initial={open.initial} onClose={close} />
    ) : open?.kind === 'maint' ? (
      <TicketFormModal initial={open.initial} onClose={close} />
    ) : null;
  return [(kind, initial) => setOpen({ kind, initial }), node];
}

export const scheduleInitial = (kind, c) =>
  kind === 'tour'
    ? { name: c.name || '', phone: c.phone || '', notes: c.home ? `Showing: ${c.home}` : '' }
    : { propertyUnit: c.type === 'tenant' ? c.home || '' : '', vendorId: c.type === 'vendor' ? c.id : '' };
